import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {Dialog, withStyles} from "@material-ui/core";
import * as actions from './store/customerDiagnoseCaseActions';
import {checkIfLoading} from "../../sc-users/User";
import AppLogoLoading from "../../sc-logo";
import CustomerDiagnoseCaseForm from "./CustomerDiagnoseCaseForm";
import {hasPermission, parseURL} from "../../sc-utilities";
import * as Yup from "yup";
import History from "../../../History";
import {
    diagnoseCaseExecutionTypes,
    diagnoseCaseGroups
} from "../../sc-admin/AdminDiagnoseCase/AdminDiagnoseCaseDetails";

const styles = (theme) => ({
    loadingScreen: {
        backgroundColor: "transparent",
        boxShadow: "none",
    },
});

const CustomerDiagnoseCaseDetails = (props) => {
    const { classes, activeCustomerID, translations, permissions, fetchCustomerDiagnoseCase, onUpdateCustomerDiagnoseCase } = props;

    const searchParams = parseURL(window.location.href);

    const [diagnoseCase, setDiagnoseCase] = useState(null);
    const [loading, setLoading] = useState({diagnoseCase: false});

    useEffect(() => {
        const getDiagnoseCase = async () => {
            setLoading(prevState => {return {...prevState, diagnoseCase: true}});
            const result = await fetchCustomerDiagnoseCase({DiagnoseCaseID: searchParams?.DiagnoseCaseID, ActiveCustomerID: activeCustomerID});
            if (result) {
                setDiagnoseCase(result);
            }
            setLoading(prevState => {return {...prevState, diagnoseCase: false}});
        }
        getDiagnoseCase();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const initialValues = {
        ShortName: diagnoseCase?.ShortName || null,
        LongName: diagnoseCase?.LongName || null,
        Description: diagnoseCase?.Description || null,
        Visible: !!diagnoseCase?.Visible,
        Group: diagnoseCase?.Group || diagnoseCaseGroups(translations)[0]?.value,
        ExecutionType: diagnoseCase?.ExecutionType || diagnoseCaseExecutionTypes(translations)[0]?.value,
        Key: diagnoseCase?.Key || null,
        ProductType: diagnoseCase?.ProductType || ""
    }

    const formSettings = {
        Validation: {
            ShortName: Yup.string().required(),
            LongName: Yup.string().required(),
            Description: Yup.string().notRequired().nullable(),
            Visible: Yup.boolean(),
            Group: Yup.string().required(),
            ExecutionType: Yup.string().required(),
            ProductType: Yup.string().required()
        },
        FormTitle: translations["edit_diagnose_case"] || "Edit diagnose case",
        ButtonSubmit: hasPermission(permissions, 'customer_diagnose_case_update') ? {
            Title: translations["save"] || "SAVE"
        } : null
    }

    const handleUpdate = async (data) => {
        await onUpdateCustomerDiagnoseCase({...data, DiagnoseCaseID: searchParams?.DiagnoseCaseID, ActiveCustomerID: activeCustomerID});
        History.goBack();
    }

    const loadingScreen = <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={checkIfLoading(loading)} PaperProps={{classes: {root: classes.loadingScreen}}}>
        <AppLogoLoading />
    </Dialog>

    return <>
        {checkIfLoading(loading)? loadingScreen : <CustomerDiagnoseCaseForm OriginalShortName={diagnoseCase?.OriginalShortName || null} OriginalLongName={diagnoseCase?.OriginalLongName || null} OriginalVisible={diagnoseCase?.OriginalVisible!==null? diagnoseCase?.OriginalVisible : null} formSettings={formSettings} initialValues={initialValues} handleSubmit={handleUpdate} translations={translations} /> }
    </>
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
    };
};
const mapDispatchToProps = dispatch => {
    return {
        fetchCustomerDiagnoseCase: id => dispatch(actions.fetchCustomerDiagnoseCase(id)),
        onUpdateCustomerDiagnoseCase: data => dispatch(actions.updateCustomerDiagnoseCase(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CustomerDiagnoseCaseDetails));
